<template>
  <div class="BusAdvertising">
    <div class="BusAdvertising__header">
      <div class="BusAdvertising__header__left">
        <div class="BusAdvertising__header__left__history">
          <ul>
            <router-link tag="li" :to="{ name: 'busmeasurement'}">
              <i class="adx-ic_arrow_left"></i>
              <span>All Campaign</span>
            </router-link>
          </ul>
        </div>
        <div v-if="isLoaded" class="BusAdvertising__header__left__title">
          <h1>{{ campaign.title }}</h1>
        </div>
        <div v-if="isLoaded" class="BusAdvertising__header__left__detail">
          <label-status class="dropdownDoc__item label" :progress="campaign.status"/>
          <span class="periode">Period of Campaign: </span>
          <span>{{ campaign.period }}</span>
        </div>
      </div>
      <div class="BusAdvertising__header__right">
        <div class= "BusAdvertising__header__right__save">
          <button v-if="!isEmpty" class="btn-large primary" @click="saveData">Save & Publish
          </button>
          <adx-loading-circle v-if="isSaved" class="loading-circle"/>
        </div>
        <button v-if="isEmpty" disabled class="btn-large primary">Save & Publish</button>
        
      </div>
    </div>
    <adx-table text="Tooltip button" 
      :loading.sync= isLoading
      :isEmpty.sync="isEmpty" 
      :dropdownItems="optionList" 
      :items.sync="data" >
    </adx-table>
    <adx-pagination 
      v-if="!isLoading && !isEmpty"
      :max-page="maxPage"
      :selected-page="currentPage"
    />
  </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'
import LoadingCircle from '@/components/Loading/Secondary-white'

import { parseErrorGql } from '@/lib/error'
import { mapGetters } from 'vuex'
import { helpers } from '@/lib/validation/'
import lib from '@/lib/util'
import moment from 'moment'

export default {
  name: 'adx-payment-order',
  components: {
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-table': table, LabelStatus,
    'adx-loading-circle': LoadingCircle,
  },
  props: {

  },
  data() {
    return {
      vehicle: [],
      id: null,
      errMess : '',
      isSaved: false,
      isLoaded: false, 
      isLoading : false, 
      campaign:{
        title : null,
        status : null,
        period : null
      },
      currentPage: 1,
      count: 0,
      maxPage: 1,
      selectedSortValue: 'last_updated',
      active: {
        'label': 'ACTIVE',
        'value': 'active'
      },
      sort: [
        {
          'id': 0,
          'label': 'Created Date',
          'value': 'first_added'
        },
        {
          'id': 1,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
        {
          'id': 2,
          'label': 'Price High to Low',
          'value': 'high_price'
        },
        {
          'id': 3,
          'label': 'Price Low to High',
          'value': 'low_price'
        },
      ],
      optionList: [
        {
          'id': 0,
          'label': 'Select Vendor',
          'value': '0',
        },
        {
          'id': 1,
          'label': 'Muliatrack',
          'value': '1',
        },
        {
          'id': 2,
          'label': 'EasyGo',
          'value': '2',
        },
      ],
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text"
          },
          {
            title: "VEHICLE ID",
            type: "input"
          },
          {
            title: "VENDOR",
            type: "dropdown"
          },
          {
            title: "VEHICLE TYPE",
            type: "text"
          },
          {
            title: "ROUTE",
            type: "text"
          },
          {
            title: "PLACEMENT",
            type: "text"
          },
        ],
        body: []
      }
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    // isComplete: function(){
    //   let inputed = []
    //   let result = this.data.body
    //   result.forEach(res => {
    //     let value = res.values[1].value
    //     if (value != ""){
    //       inputed.push({key : value})
    //     }
    //   })
    //   let a = result.length
    //   let b = inputed.length
    //   if (a == b){
    //     return true
    //   } else {
    //     return false
    //   }
    // },
  },
  watch: {
  },
  // apollo: {
  //   busMeasurementVehicles: {
  //     query: require('@/graphql/bus/measurementVehicle.gql'),
  //     loadingKey: 'loading',
  //     variables(){
  //       return {
  //         id: this.id,
  //       }
  //     },
  //     result(data) {
  //       const { busMeasurementVehicles } = data.data
  //       if (busMeasurementVehicles){
  //         this.mapData(busMeasurementVehicles)
  //       }
  //     }
  //   }
  // },
  beforeCreate() {
    
  },
  created() {

  },
  beforeMount() {
    this.isLoaded = false
    this.id = this.$route.params.id
  },
  mounted() {
    this.busCampaign()
    this.busVehicle()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async busCampaign(){
      this.isLoaded = false
      let failed = false
      let res = null
      try {
        res = await  this.$apollo.query({
          query:require('@/graphql/bus/busMeasurementPage.gql'),
          loadingKey:'loading',
          errorPolicy:'all',
          fetchPolicy:'network-only',
          variables:{
            id: this.id
          }
        })
      } catch(err) {
        failed = true
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Network error!`,
          type: 'danger'
        });
        this.$router.push({ name: `500` })
      }
      if (!failed){
        if (res.data){
          if (res.errors){
            this.handleError(res.errors)
          } else {
            const { busCampaignMeasurement } = res.data
            let campaign = busCampaignMeasurement
            this.campaign ={
              title : campaign.campaign,
              status : this.getStatusDisplay(campaign.status),
              period : this.displayPeriod(campaign.start, campaign.end)
            }
            this.isLoaded = true
          }
        }
      }
    },
    async busVehicle(){
      this.isLoading = true
      const res = await  this.$apollo.query({
        query:require('@/graphql/bus/measurementVehicle.gql'),
        loadingKey:'loading',
        fetchPolicy:'network-only',
        errorPolicy:'all',
        variables:{
          id: this.id
        }
      })
      if (res.data){
        const { busMeasurementVehicles } = res.data
        if (busMeasurementVehicles){
          this.mapData(busMeasurementVehicles)
        }
        this.isLoading = false
      }
    },
    async mapData(data){
      let body = []
      let index = 1
      
      const routes = data
      await routes.forEach(route=> {
        let valuesData = [
          { value: index},
          { value: route.vehicleId},
          { value: route.vendor.toString()},
          { value: "Big Bus"},
          { value: route.route.title},
          { value: route.route.placement},
        ]
        body.push({
          id: route.id,
          values: valuesData
        })
        index += 1
      });
      this.data.body = body
    },
    async saveData(){
      this.isSaved = true
      this.errMess = ''
      let data = this.data.body
      let validation = this.inputValidation(data)
      let result = null
      let flag = true
      
      if(validation.isValid){
        for (let index = 0; index < data.length; index++) {
          const res = data[index]
          try{
            let id = res.id
            let vehicle = res.values[1].value
            let vendor = parseInt(res.values[2].value)
            result =  await this.$apollo.mutate({
              mutation: require('@/graphql/bus/updateMeasurementBus.gql'),
              errorPolicy:'all',
              loadingKey:'loading',
              fetchPolicy: 'no-cache',
              variables: {
                id: id,
                busMeasurementVehicle:{
                  vehicleId: vehicle,
                  vendor: vendor
                }
              }
            })
          } catch(err){
            this.errMess = 'Error Network. Failed to fetch'
          }
          if (result && result.data){
            if (result.errors){
              this.handleError(res.errors)
            }
          }
        }
        this.isSaved = false
        await this.notification()
      } else{
        this.raiseError(validation.errorMessage)
      }
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    },
    getStatusDisplay(status){
      let state = status.toLowerCase()
      let res = []
      switch(state){
        case `draft`:
          res = { id: 0, value: 'expired', label: 'DRAFT', status: 'expired'}
          break
        case `verifying`:
          res = { id: 0, value: 'verifying', label: 'VERIFYING', status: 'verifying'}
          break
        case `active`:
          res = { id: 1, value: 'active', label: 'ACTIVE', status: 'active'}
          break
        case `expired`:
          res = { id: 2, value: 'expired', label: 'EXPIRED', status: 'expired'}
          break
        case `canceled`:
          res = { id: 3, value: 'canceled', label: 'CANCELED', status: 'canceled'}
          break
        case `dormant`:
          res = { id: 4, value: 'dormant', label: 'DORMANT', status: 'dormant'}
          break
        case `upcoming`:
          res = { id: 4, value: 'upcoming', label: 'UPCOMING', status: 'upcoming'}
      }
      return res
    },
    inputValidation(result) {
      let data = { isValid: true, errorMessage: null }
      let isValid = true
      result.forEach(res=> {
        let vehicle = res.values[1].value
        let vendor = parseInt(res.values[2].value)
        if (vehicle == "" && vendor != 0) {
          data.isValid = false
          data.errorMessage = "You can't leave vehicle empty while vendor selected"
          isValid = false
        } else if (vehicle != "" && vendor == 0) {
          data.isValid = false
          data.errorMessage = "Please select the vendor name"
          isValid = false
        }
      })
      return data
    },
    raiseError(errorMessage) {
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: errorMessage,
        type: 'danger'
      });
    },
    async handleError(error) {
      const parsedError = await parseErrorGql(error)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if(parsedError.code === 204) code = 404
          this.$router.push({name: `${code}`})
        } else if(parsedError.code === 502){
          this.count++
          if (this.count<3){
            await this.busCampaign()
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Something went wrong. Please refresh the page!`,
              type: 'danger'
            });
            this.isLoaded = true
          }
        } else {
          this.$router.push({ name: `500` })
        }
      }
    },
    notification() {
      if (this.errMess == '') {
        this.$notify({
          group: 'saved',
          title: 'Success',
          text: `Data successfully saved!`,
          type: 'success'
        });
        this.busVehicle()
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: this.errMess,
          type: 'danger'
        });
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
.BusAdvertising {
  .selectDropdown {
    .selectTable {
      width: max-content;
    }
  }
}
</style>